import {
  authOutlinedInputSurfaceSx,
  borderInput,
  palettePrimaryMain,
  surfaceAuthCard,
  textPrimary,
} from '@/theme/designTokens'

export const inputSx = {
  ...authOutlinedInputSurfaceSx,
  height: 50,
  borderRadius: '8px',
  fontSize: '16px',
  letterSpacing: '-0.9525px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: borderInput,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: borderInput,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: borderInput,
    borderWidth: '1px',
  },
  /** MUI InputBase sets `background: none` on the native input — must set `background` shorthand too. */
  '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
    px: '16px',
    py: '14px',
    background: surfaceAuthCard,
    backgroundColor: surfaceAuthCard,
    '&::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
  },
  '& .MuiInputAdornment-root': {
    background: surfaceAuthCard,
    backgroundColor: surfaceAuthCard,
  },
  '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
    WebkitBoxShadow: `0 0 0 100px ${surfaceAuthCard} inset`,
    WebkitTextFillColor: textPrimary,
    caretColor: textPrimary,
  },
} as const

export const errorInputSx = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ef4444',
  },
} as const

export const labelSx = {
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '20px',
  color: textPrimary,
  mb: '8px',
} as const

export const headingSx = {
  fontWeight: 700,
  fontSize: { xs: '24px', md: '32px' },
  lineHeight: { xs: '32px', md: '40px' },
  color: textPrimary,
  textAlign: 'center',
} as const

export const subtitleSx = {
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  color: textPrimary,
  textAlign: 'center',
  opacity: 0.85,
} as const

export const primaryButtonSx = {
  bgcolor: palettePrimaryMain,
  borderRadius: '8px',
  height: 52,
  fontWeight: 500,
  fontSize: '16px',
  textTransform: 'none',
  color: '#ffffff',
  '&:hover': {
    bgcolor: '#007bb8',
  },
  '&.Mui-disabled': {
    bgcolor: '#94a3b8',
    color: '#ffffff',
  },
} as const
